import { sample } from 'effector';
import { $answers } from 'models/answers';
import { $global } from 'models/store-global';

sample({
    source: $global.map((store) => store.answers || null),
    target: $answers,
});
